export default "__VITE_ASSET__CvISUO1___"